import { AP } from './appointments';

export type TReceiptDiscountTypeIds = 'PERCENTAGE' | 'AMOUNT';

export type TReceiptPayment = {
    amount: number;
    paymode: RECEIPT_PAYMENT_MODE_ID;
};
export enum RECEIPT_PAYMENT_MODE_ID {
    CASH = 'CASH',
    UPI = 'UPI',
    DEBIT_CARD = 'DEBIT_CARD',
    GPAY = 'GPAY',
    PAYTM = 'PAYTM',
    CREDIT_CARD = 'CREDIT_CARD',
    OTHER = 'OTHER',
    EKA_POSTPAY = 'EKA_POSTPAY',
    EKA_PREPAID = 'EKA_PREPAID',
    EKA_WALLET = 'EKA_WALLET',
}

export enum DISCOUNT_TYPE {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
}

export type TReceipt = {
    additional_discount_amount: number;
    additional_discount_type: DISCOUNT_TYPE;
    additional_discount_value: number;
    mobile: string;
    name: string;
    remarks: string;
    net_amount: number;
    receipt_amount: number;
    receipt_id: number;
    receipt_number?: string;
    receipt_url: string | null;
    receipt_payment: Array<TReceiptPayment>;
    receipt_sku: Array<TReceiptSku>;
    updated_at: string | null;
    payment_status: PAYMENT_STATUS;
    receipt_type: RECEIPT_TYPE;
    amount_due: number;
    payment_id: string;
    ref_trx_id?: string;
};

export enum RECEIPT_TYPE {
    INCLINIC = 'INCLINIC',
    EKAPREPAID = 'EKAPREPAID',
    REFUND = 'REFUND',
    DUE_PAYMENT = 'DUE_PAYMENT',
    CREDIT_NOTE = 'CREDIT_NOTE',
}

export enum PAYMENT_STATUS {
    UNBILLED = 'unbilled',
    SUCCESS = 'success',
    FAILED = 'failed',
    CREATED = 'created',
    TO_REFUND = 'to_refund',
    REFUND_PROCESSED = 'refund_processed',
    REFUNDED = 'refunded',
    CANCELLED = 'cancelled',
}

export type TReceiptSku = {
    net_amount: number;
    amount: number;
    discount_amount: number;
    discount_type: DISCOUNT_TYPE;
    discount_value: number;
    quantity: number;
    sku_item: TSkuItem;
};

export type TSkuItem = {
    service_name: string;
    service_id: number;
    price: number;
    archive: boolean;
};

export const paymentStatusMap: Record<string, string> = {
    created: 'pending',
    payment_initiated: 'pending',
    cancelled: 'pending',

    payment_success: 'paid',
    payment_processing: 'paid',
    success: 'paid',
    settled: 'paid',

    unbilled: 'unbilled',

    receipt_generated: 'paid',

    refunded: 'refunded',
    refund_processed: 'refunded',
    to_refund: 'refunded',

    payment_failed: 'failed',
    failed: 'failed',
};

export function getReceiptPaidAmount(a: AP) {
    let isReceiptGeneratedForPrepaidApt = false;

    let billTotal = a.receipts.reduce((acc, curr) => {
        if (curr.receipt_payment.length) {
            curr.receipt_payment.forEach((item) => {
                if (item.paymode === RECEIPT_PAYMENT_MODE_ID.EKA_PREPAID) {
                    isReceiptGeneratedForPrepaidApt = true;
                }
            });
        }

        if (
            curr.net_amount &&
            (!curr.payment_id ||
                paymentStatusMap.receipt_generated === paymentStatusMap[curr.payment_status])
        ) {
            return acc + curr.net_amount;
        }

        return acc;
    }, 0);

    if (!isReceiptGeneratedForPrepaidApt) {
        billTotal += a.payment_status === 'success' ? a.amount || 0 : 0;
    }

    return billTotal;
}
